module.exports = __webpack_public_path__ + "static/employee_her-cdab679b1c1172a76ed59648d1bbb587.jpg";